import { css } from 'styled-components';

export const PastelDreamSkin = css`
  background: linear-gradient(180deg, #ffdee9 0%, #b5fffc 100%);
  border-radius: 20px;
  box-shadow: 0 0 10px #ffb6c1;
`;

export const PastelDreamWrapperSkin = css`
  background: linear-gradient(180deg, #ffdee9 0%, #b5fffc 100%);
`;

export const PastelDreamLetterSkin = css<{ $isActive: boolean }>`
  color: ${props => (props.$isActive ? '#70429c' : '#9c9c9c')};
  opacity: ${props => (props.$isActive ? 1 : 0.3)};
`;
